<template>
  <div id="servicos">
    <v-container class="py-15">
      <v-row>
        <v-col cols="12" md="6" offset-md="3">
          <div class="text-center">Conheça nossos</div>
          <TitleWidget>Serviços</TitleWidget>
        </v-col>
      </v-row>
      <v-row v-if="!smAndDown" justify="center" class="mt-5">
        <v-col cols="6" md="3" :key="key" v-for="(item, key) in items">
          <ServiceCard :item="item" />
        </v-col>
      </v-row>
      <CarouselWidget
        v-if="items.length && smAndDown"
        :items="items"
        :itemsToShow="{
          xs: 1.2,
          sm: 2,
          md: 2,
          lg: 3,
          xl: 3,
        }"
        :gap="20"
        dots
        class="my-10"
      >
        <template #item="{ item }">
          <ServiceCard :item="item" />
        </template>
      </CarouselWidget>
      <ButtonWidget class="mt-10" :align="'center'" to="/atendimento">
        Solicite orçamento
      </ButtonWidget>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import { formatToURL } from "../../utils/formatToURL";
import ServiceCard from "../cards/ServiceCard.vue";
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "services",
  path: "/servicos",
};

export default {
  // data: () => ({}),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ id, img, title }) => ({
        img,
        title,
        to: `${_config.path}/${formatToURL(title)}-${id}`,
      }));
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.$rest(_config.mod).get();
  },
  components: {
    TitleWidget,
    ServiceCard,
    CarouselWidget,
    ButtonWidget,
  },
};
</script>

<style>
#servicos {
  background: #fff;
  border-bottom-left-radius: 100px;
  border-bottom-right-radius: 100px;
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.08);
  padding-bottom: 50px;
  position: relative;
  z-index: 1;

  @media (max-width: 600px) {
    padding-bottom: 0;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
}
</style>
